import {all, call, fork, put, select, takeLatest} from 'redux-saga/effects'
import types from 'actions/types'
import {push} from 'react-router-redux'
import {generalError} from 'actions/index'
import {getMainRoute} from 'selectors/routing'
import {
  getOpenCompanies,
  getRecentContacts,
  getSelectedCompanyId,
  getSelectedContactId,
} from 'selectors/contacts'
import {getSelectedOrderId} from 'selectors/quotes'
import {getSelectedPurchaseOrderId} from 'selectors/purchasing'
import {getNewPathForCompanyContactChange, getNewPathForTabChange} from 'helpers/navigation'
import {getCurrentTab} from 'selectors/navigation'
import {get, isEmpty, isNil} from 'lodash'
import {findContactIdForOpenCompany, findMostRecentContactForCompany} from 'helpers/contacts'
import {snackbarMessage} from 'actions/snackbar'

export default (api) => {

  // Navigates to the selected contact (ROUTE CHANGE ONLY!)
  function* selectContact({contactId, companyId}) {
    try {
      const mainRoute = yield select(getMainRoute)
      const tab = yield select(getCurrentTab)
      const path = getNewPathForCompanyContactChange(mainRoute, companyId, contactId, tab)
      yield put(push(path))
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* selectContactForCompany({companyId}) {
    try {
      const openCompanies = yield select(getOpenCompanies)
      const recentContacts = yield select(getRecentContacts)

      const openContactId = findContactIdForOpenCompany(openCompanies, companyId)
      if (!isNil(openContactId)) {
        yield call(selectContact, {contactId: openContactId, companyId})
        return
      }

      const recentContactId = findMostRecentContactForCompany(recentContacts, companyId)
      if (!isNil(recentContactId)) {
        yield call(selectContact, {contactId: recentContactId, companyId})
        return
      }

      const params = {companyId, main: true}
      const fields = {id: true}

      const response = yield call(api.contact.get, params, fields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            const contacts = data.result

            if (isEmpty(contacts)) {
              yield put(snackbarMessage("No main contact found for this company"))
              return
            }

            const contactId = get(contacts, '[0].id')
            yield call(selectContact, {contactId, companyId})
          },
          function* onFail(key, message) {
            const error = `Error locating contact: ${message}`
            console.error(error)
            yield put(snackbarMessage(message))
          }
      )

    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  /**
   * Navigates to the selected tab (ROUTE CHANGE ONLY!)
   * @param tab the navigation tab to link to
   * @param id - The id of the element to scroll to. Will be appending to  URL as a hash
   */
  function* selectTab({tab, id = ''}) {

    try {
      // Push a route change to the new tab for the same contact or company
      const mainRoute = yield select(getMainRoute)
      const curCompanyId = yield select(getSelectedCompanyId)
      const curContactId = yield select(getSelectedContactId)
      const curQuoteId = yield select(getSelectedOrderId)
      const curPurchaseOrderId = yield select(getSelectedPurchaseOrderId)
      const path = getNewPathForTabChange(mainRoute, tab, id, curCompanyId, curContactId, curQuoteId, curPurchaseOrderId)
      yield put(push(path))

    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }


  function* myWatcher() {
    yield all([
      takeLatest(types.NAVIGATION_SELECT_CONTACT, selectContact),
      takeLatest(types.NAVIGATION_SELECT_COMPANY, selectContactForCompany),
      takeLatest(types.NAVIGATION_SELECT_CONTACT_FOR_COMPANY, selectContactForCompany),
      takeLatest(types.NAVIGATION_SELECT_TAB, selectTab),
    ])
  }

  function* watcher() {
    yield fork(myWatcher)
  }

  return {
    watcher,
  }
}
